export function formatReadableErrorMessage(message: string | null | undefined): string {
    if (message == null || message === "") {
      return "";
    }
    return message
      .replace(/[-_]+/g, " ")
      .replace(/err/g, "Error")
      .toLowerCase()
      .replace(/\b\w/g, (c: string) => c.toUpperCase());
  }